import { SimpleGrid, Title, Text, Container, Grid, Image, Button } from '@mantine/core';
import globalImg from '../Images/GlobalCooperations.png';
import logo_cooperate from '../Images/cooperate_logo2.png';

const Imprint = () => {
    //const theme = useMantineTheme();

    return (
        <section id="imprint">
            <Container>
                <Grid justify="space-around">
                    <Grid.Col xs={12} sm={8} md={8} lg={8}>
                        <div>
                            <Text color="black">
                                <Title order={1}>Imprint</Title>
                                 
                                 <p><strong>Imprint of DANAXSSERT International Trading GmbH</strong></p>
                                   <p>
                                    <strong>DANAXSSERT International Trading GmbH</strong><br />
                                    Kronprinzenstr.14 <br />65185 Wiesbaden <br />Germany <br />
                                   </p>
                                   <p>
                                    <strong>Contact</strong> <br />   
                                    Telefon: +49 1607683035 <br /> 
                                    E-Mail:<a href="mailto:sales@danaxssert.de"> sales@danaxssert.de </a> <br />
                                    Internet: https://international-trading.danaxssert.de <br />
                                   </p>
                                   <p>
                                   <strong>VAT Number</strong><br /> DE361163826  <br />
                                   </p>
                                   <p>
                                    <strong>Register Entries</strong><br /> Registration Court: Court Wiesbaden HRB 34109 <br />
                                   </p>
                
                                   <p>
                                    <strong>Director</strong> <br /> Piao Wang <br /> 
                                   </p>
                            </Text>
                        </div>
                        
                    </Grid.Col>
                    <Grid.Col xs={12} sm={4} md={4} lg={3.5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    
       

    <SimpleGrid cols={1} spacing="xl" verticalSpacing="xs">
      
      <Container>

                       <Image
                          radius="md"
                          src={globalImg}
                          alt={'sample1'}
                          style={{ width: '100%' }}
                     />
</Container>
<Container>
                       <Image
                          radius="md"
                          src={logo_cooperate}
                          alt={'sample1'}
                          style={{ width: '100%' }}
                     />
</Container>

    </SimpleGrid>


                    </Grid.Col>
      
                </Grid>


            </Container>
        </section>
    )
};

export default Imprint;
